export enum HeaderHeight {
  small = 'small',
  big = 'big',
}
